<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">雇主险管理-修改</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<!-- 查询框 -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<el-form-item label="保单名称" prop="insurance_name" style="margin-top:80px;width:80%">
								<el-input v-model="ruleForm.insurance_name" placeholder="请输入保单名称"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="投保账户" prop="insure_account" style="margin-top:80px;width:80%">
								<el-input v-model="ruleForm.insure_account" placeholder="请输入投保账户"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="承保公司" prop="company_id">
								<el-select v-model="ruleForm.company_id" style="width:74%" placeholder="请选择承保公司"
									clearable>
									<el-option v-for="item in cbgsList" :key="item.id" :label="item.company_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="生效时间">
								<el-col :span="9">
									<el-form-item prop="start_date">
										<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="请选择"
											v-model="ruleForm.start_date" style="width:88%"></el-date-picker>
									</el-form-item>
								</el-col>
								<el-col class="line" :span="1"> - </el-col>
								<el-col :span="9">
									<el-form-item prop="end_date">
										<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="请选择"
											v-model="ruleForm.end_date" style="width:88%"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="保单号" prop="policy_no" style="width:80%">
								<el-input v-model="ruleForm.policy_no" placeholder="请输入保单号"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="投保人数" prop="insure_number" style="width:80%">
								<el-input v-model="ruleForm.insure_number" placeholder="请输入投保人数"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="单价" prop="unit_price" style="width:80%">
								<el-input v-model="ruleForm.unit_price" placeholder="请输入单价"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="保费" prop="premium" style="width:80%">
								<el-input v-model="ruleForm.premium" placeholder="请输入保费"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="保额" prop="insured_amount" style="width:80%">
								<el-input v-model="ruleForm.insured_amount" placeholder="请输入保额"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="免赔额、比例" prop="proportion" style="width:80%">
								<el-input v-model="ruleForm.proportion" placeholder="请输入免赔额、比例"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<div style="height:200px; overflow-y:scroll;">
						<el-form-item label="适用范围：" prop="region">
								<el-row v-for="(item, index) in rangeListIndex" :key="index"
									style="margin-bottom: 20px;">
									<el-form :model="ruleForm.rangeList[index]" :rules="rangeRules" ref="rangeRuleForm">
										<el-col :span="12">
											{{$globals.group_name + '>' + ruleForm.rangeList[index].range}}
										</el-col>
										<el-col :span="4">
											{{ruleForm.rangeList[index].post_name}}
										</el-col>
										<el-col :span="4">
											{{ruleForm.rangeList[index].dataName != null && ruleForm.rangeList[index].dataName != '' ? ruleForm.rangeList[index].dataName : '不限'}}
										</el-col>
										<el-col :span="4">
											{{ruleForm.rangeList[index].gender != null && ruleForm.rangeList[index].gender != '' ? (ruleForm.rangeList[index].gender == '1' ? '男' : '女') : '不限'}}
										</el-col>
									</el-form>
								</el-row>
							</el-form-item>
					</div>

					<el-form-item label="适用范围">
						<el-row v-for="(item, index) in rangeListIndexs" :key="index" style="margin-bottom: 20px;">
							<el-form :model="rangeList[index]" :rules="rangeRules" ref="rangeRuleForm">
								<el-col :span="8">
									<el-form-item prop="organize_ids">
										<el-cascader v-model="rangeList[index].organize_ids" clearable
											style="width:100%;" collapse-tags :props="props" placeholder="请选择组织架构"
											@change="changeCascade(index)"></el-cascader>
									</el-form-item>
								</el-col>
								<el-col :span="4">
									<el-form-item prop="post_ids">
										<el-select v-model="rangeList[index].post_ids" placeholder="请选择岗位"
											clearable style="width:95%; margin-left: 5%;" multiple collapse-tags filterable >
											<el-option v-for="post in postList" :key="post.id" :label="post.post_name"
												:value="post.id">
											</el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :span="4">
									<el-select v-model="rangeList[index].age_id" placeholder="请选择年龄段" clearable
										style="width:95%; margin-left: 5%;">
										<el-option v-for="age in ageList" :key="age.id" :label="age.data"
											:value="age.id">
										</el-option>
									</el-select>
								</el-col>
								<el-col :span="4">
									<el-select v-model="rangeList[index].gender" placeholder="请选择性别" clearable
										style="width:95%; margin-left: 5%;">
										<el-option v-for="(sex, sexIndex) in sexList" :key="sexIndex" :label="sex.lable"
											:value="sex.value">
										</el-option>
									</el-select>
								</el-col>
								<el-col :span="4">
									<img src="../../../assets/icon/添加.png"
										style="height: 25px; margin-left: 5%; margin-top: 5px;"
										v-show="index == (rangeListIndexs - 1)" @click="AddRecord" />
									<img src="../../../assets/icon/减少.png"
										style="height: 25px; margin-left: 10px; margin-top: 5px;" v-show="index != 0"
										@click="RemoveRecord(index)" />
								</el-col>
							</el-form>
						</el-row>
					</el-form-item>


					<el-row>
						<el-col :span="12">
							<el-form-item label="承保公司联系人" prop="company_contacts" style="width:80%">
								<el-input v-model="ruleForm.company_contacts" placeholder="请输入承保公司联系人"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="承保公司联系电话" prop="company_telephone" style="width:80%">
								<el-input v-model="ruleForm.company_telephone" placeholder="请输入承保公司联系电话"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="备注" prop="remarks">
						<el-input v-model="ruleForm.remarks" style="width:89%" placeholder="请输入备注内容"></el-input>
					</el-form-item>

					<el-row>
						<el-col :span="12">
							<el-form-item label="备用1" prop="spare1" style="width:80%">
								<el-input v-model="ruleForm.spare1" placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="备用2" prop="spare2" style="width:80%">
								<el-input v-model="ruleForm.spare2" placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="批改扫描件" prop="insurance_url">
								<el-upload :action="$globals.http + '/file/upload'" list-type="picture-card"
									:on-preview="handlePictureCardPreview" :limit="1" :on-remove="handleRemove"
									:on-success="handleAvatarSuccess">
									<i class="el-icon-plus"></i>
								</el-upload>
								<el-dialog :visible.sync="dialogVisible">
									<img width="100%" :src="ruleForm.insurance_url" alt="">
								</el-dialog>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="其他附件" prop="enclosure_url" style="width:80%">
								<el-upload class="upload-demo" :action="$globals.http + '/file/upload'"
									:on-preview="handlePreview" :on-remove="handleRemove" :on-success="uploadFujian"
									:before-remove="beforeRemove" multiple :on-exceed="handleExceed"
									:file-list="fileList" :v-model="ruleForm.enclosure_url">
									<el-button type="goon" style="font-size:10px;width:100px">上传附件</el-button>
								</el-upload>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item style="margin-left:550px">
						<el-button type="goon" @click="Add">保存</el-button>
					</el-form-item>
				</el-form>

			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {

				//适用范围
				rangeListIndex: 1,
				//适用范围
				rangeListIndexs: 1,

				//表单数据
				ruleForm: {
					id: '',
					insurance_name: '',
					insure_account: '',
					company_id: '',
					start_date: '',
					end_date: '',
					policy_no: '',
					insure_number: '',
					unit_price: '',
					premium: '',
					insured_amount: '',
					proportion: '',
					company_contacts: '',
					company_telephone: '',
					remarks: '',
					spare1: '',
					spare2: '',
					insurance_url: '',
					enclosure_url: '',
					rangeList: [{
						organize_id: "",
						organize_ids: [],
						post_id: "",
						post_ids:[],
						age_id: "",
						gender: "",
						flag: 0
					}],
				},

				rangeList: [{
					organize_id: "",
					organize_ids: [],
					post_id: "",
					post_ids:[],
					age_id: "",
					gender: "",
					flag: 0
				}],

				//表单验证
				rules: {
					insurance_name: [{
						required: true,
						message: '请输入保单名称',
						trigger: 'blur'
					}, ],
					insure_account: [{
						required: true,
						message: '请输入投保账户',
						trigger: 'blur'
					}],
					company_id: [{
						required: true,
						message: '请选择承保公司',
						trigger: 'change'
					}],
					start_date: [{
						required: true,
						message: '请选择开始时间',
						trigger: 'blur'
					}],
					end_date: [{
						required: true,
						message: '请选择结束时间',
						trigger: 'blur'
					}],
					policy_no: [{
						required: true,
						message: '请输入保单号',
						trigger: 'blur'
					}],
					insure_number: [{
						required: true,
						message: '请输入投保人数',
						trigger: 'blur'
					}],
					unit_price: [{
						required: true,
						message: '请输入单价',
						trigger: 'blur'
					}],
					premium: [{
						required: true,
						message: '请输入保费',
						trigger: 'blur'
					}],
					insured_amount: [{
						required: true,
						message: '请输入保额',
						trigger: 'blur'
					}],
					proportion: [{
						required: true,
						message: '请输入免赔额、比例',
						trigger: 'blur'
					}],
					company_contacts: [{
						required: true,
						message: '请输入承保公司联系人',
						trigger: 'blur'
					}],
					company_telephone: [{
						required: true,
						message: '请输入承保公司联系电话',
						trigger: 'blur'
					}],
					insurance_url: [{
						required: true,
						message: '请上传批改扫描件',
						trigger: 'blur'
					}],
				},

				//适用范围验证
				rangeRules: {
					organize_ids: [{
						required: true,
						message: '请选择组织架构',
						trigger: 'blur'
					}],
					post_ids: [{
						required: true,
						message: '请选择岗位',
						trigger: 'blur'
					}]
				},

				//承保公司数据
				cbgsList: [],

				//年龄范围数据
				ageList: [],

				//岗位数据
				postList: [],

				//性别数据
				sexList: [{
					value: 0,
					lable: '女'
				}, {
					value: 1,
					lable: '男'
				}],

				//组织架构数据
				organizeList: [],

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: true,
				},
			};
		},
		methods: {
			//添加记录
			AddRecord() {
				this.rangeListIndexs += 1;
				this.$set(this.rangeList, this.rangeList.length, {
					organize_id: "",
					organize_ids: [],
					post_id: "",
					age_id: "",
					gender: "",
					flag: this.rangeList.length,
				});
			},
			//移除记录
			RemoveRecord(e) {
				this.rangeListIndexs -= 1;
				this.rangeList.splice(e, 1);
			},
			//级联修改
			changeCascade(index) {
				this.rangeList[index].organize_id = '';
				this.rangeList[index].organize_ids.forEach(item => {
					this.rangeList[index].organize_id += item + ',';
				})
			},
			handleAvatarSuccess(res, file) {
				this.ruleForm.insurance_url = res.data.fileUrl;
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			uploadFujian(res, file) {
				this.ruleForm.enclosure_url = res.data.fileUrl;
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			//添加
			Add() {
				var falg = false;

				this.$refs["rangeRuleForm"].forEach(item => {
					item.validate(valid => {
						falg = valid;
					});
				})

				this.$refs["ruleForm"].validate(async (valid) => {
					if (valid && falg) {
						var url = 'Employer/updateByPrimaryKey';
						var record = {
							id: this.ruleForm.id,
							insurance_name: this.ruleForm.insurance_name,
							insure_account: this.ruleForm.insure_account,
							company_id: this.ruleForm.company_id,
							start_date: this.ruleForm.start_date,
							end_date: this.ruleForm.end_date,
							policy_no: this.ruleForm.policy_no,
							insure_number: this.ruleForm.insure_number,
							unit_price: this.ruleForm.unit_price,
							premium: this.ruleForm.premium,
							insured_amount: this.ruleForm.insured_amount,
							proportion: this.ruleForm.proportion,
							company_contacts: this.ruleForm.company_contacts,
							company_telephone: this.ruleForm.company_telephone,
							remarks: this.ruleForm.remarks,
							spare1: this.ruleForm.spare1,
							spare2: this.ruleForm.spare2,
							insurance_url: this.ruleForm.insurance_url,
							enclosure_url: this.ruleForm.enclosure_url,
							rangeList: this.rangeList,
						};
						var data = await this.$globals.AxiosPost(url, record);
						if (data === '-2000') {
							this.$message.error('服务器未响应！请稍后重试');
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.Return();
							} else {
								this.$message.warning(data);
							}
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			Return() {
				this.$parent.Return();
				
			},

			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
				});
				this.organizeList = this.getTreeData(organizeList.data);

			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			}
		},
		async created() {
			this.ruleForm = this.$parent.ruleForm;
			this.organizeFind();
			// 岗位
			var postList = await this.$globals.AxiosPost("post/selectFind", {});
			this.postList = postList.data;
			// 承保公司
			var cbgsList = await this.$globals.AxiosPost("company/SelectAll", {});
			this.cbgsList = cbgsList.data;
			// 年龄段类型
			var ageList = await this.$globals.AxiosPost("/dictionaries/selectFind", {
				data_grouping: "age_group"
			});
			this.ageList = ageList.data;
		},
		
		watch: {
			"ruleForm.rangeList"(newValue) {
				this.rangeListIndex = newValue.length;
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Gzxgl_modify.vue?04840e7c